import { log } from "./log";

export const collectTimings = (): void => {
  setTimeout(() => {
    for (const metric of window.performance.getEntries()) {
      if (metric.entryType === "paint" || metric.entryType === "navigation") {
        log(metric.toJSON());
      }
    }
  }, 500);
};
